import {i18n} from "../i18n";
import {store} from "./mainStore";

const emailSubj = textKey => {
	return `mailto:support@deckofdice.com?subject=${encodeURI(i18n.t(textKey))}
		&body=${encodeURI(i18n.t('email-body')
			.replace('*plrID*', store.user.guest.serverData.UserId)
			.replace('*platform*', store.isIOS ? 'IOS' : 'Android')
			.replace('*device*', store.deviceModel || '')
			.replace('*os*', store.osVersion || '')
			.replace('*country*', store.countryCode || '')
			.replace('*lang*', window.rawLang.toUpperCase() || '')
			.replace('*connect*', store.connectionType || '')
		)}
	`;
}

const remoteFolder = (store.isDev && store.cfgFolder === 'dev') ? '/REMOTE' 
	: ('https://uncached-messages.s3.us-east-2.amazonaws.com/'+ store.cfgFolder);

const SiuConstants = {
	TOS_LINK: 'https://deckofdicegaminginc.com/terms-of-service',
	PP_LINK: 'https://deckofdicegaminginc.com/privacy-policy',
	FAQ_LINK: 'https://gdoc.pub/doc/e/2PACX-1vT9PEzr7nfXahIsrIz_RLFyniSUWATUQ6IPejwihB2tc3QKZ8nZcBLao12ebTgRmC1hGF93lOHONORX',
	SMS_MSG: "send-sms?playerid=*playerid*&number=&body=I'm having fun playing SHAKE IT UP! Dice Poker – install now and LET'S ROLL! 🎲🎉 ", // onelink.to/shakeitupdice",
	// SMS_MSG: "send-sms?&number=&body=I'm having fun playing SHAKE IT UP! Dice Poker – install now and LET'S ROLL! 🎲🎉 ", // onelink.to/shakeitupdice",
	remotePath: remoteFolder + '/SIU',
	eventConfig: remoteFolder + '/SIU/eventsConfig.json',
	promoConfig: remoteFolder + '/SIU/promoConfig.json',
	weekConfig: remoteFolder + '/SIU/weekConfig.json',
	MAIL_TO: () => emailSubj('email-subj-siu'),

	BUTTON_SCHEME: {
		topShadows: 'inset 0 0 0.75vw 0 topShadowColor',
		bottomShadows: `inset 0 0.25vw 0.5vw 0 bottomShadowColor, 
			0 0.75vw 1.25vw #00000066`,
		blue: {
			bottomGrad: '#3459ab 0%,#2a4a96 15%,#254182 35%,#254182 65%,#2a4a96 85%,#3459ab 100%',
			bottomShadowColor: '#5087d8',
			topGrad: '#6dabff,#3f6ac9',
			topShadowColor: '#a9ceff'
		},
		green: {
			bottomGrad: '#267e22 0%,#276824 15%,#245c21 35%,#245c21 65%,#276824 85%,#267e22 100%',
			bottomShadowColor: '#40ab2e',
			topGrad: '#5adf49,#328c24',
			topShadowColor: '#8fe684'
		},
		grey: {
			bottomGrad: '#8a8a8a 0%,#6c6c6c 15%,#585858 35%,#585858 65%,#6c6c6c 85%,#8a8a8a 100%',
			bottomShadowColor: '#aaaaaa',
			topGrad: '#c1c1c1,#8a8a8a',
			topShadowColor: '#d7d7d7'
		},
		red: {
			bottomGrad: '#c60b21 0%,#a1041f 15%,#7d0806 35%,#7d0806 65%,#a1041f 85%,#c60b21 100%',
			bottomShadowColor: '#ff6360',
			topGrad: '#ff5350,#c60b21',
			topShadowColor: '#ff6360'
		},
		purple: {
			bottomGrad: '#7135b9 0%,#5a2b91 15%,#4d2878 35%,#4d2878 65%,#5a2b91 85%,#7135b9 100%',
			bottomShadowColor: '#9052d9',
			topGrad: '#c380f7,#6c20c3',
			topShadowColor: '#ce97f9'
		},
		yellow: {
			bottomGrad: '#dd903f 0%,#dd7035 15%,#b6541f 35%,#b6541f 65%,#dd7035 85%,#dd903f 100%',
			bottomShadowColor: '#fddd5d',
			topGrad: '#fcc943,#ff9c3c',
			topShadowColor: '#fddd5d',
			//textColor: '#85380b'
		},
		black: {
			bottomGrad: '#2a2a2a 0%,#1c1c1c 15%,#121212 35%,#121212 65%,#1c1c1c 85%,#2a2a2a 100%',
			bottomShadowColor: '#434343',
			topGrad: '#333333,#1a1a1a',
			topShadowColor: '#434343'
		}
	}
}

const HardRockConstants = {
	TOS_LINK: 'https://www.hardrockdigital.com/dice-party-tos',
	PP_LINK: 'https://www.hardrockdigital.com/games-privacy',
	FAQ_LINK: 'https://deckofdicegaminginc.com/hrdp-game-faq/',
	SMS_MSG: "send-sms?playerid=*playerid*&number=&body=I’m having fun playing HARD ROCK DICE PARTY – install now and LET’S ROLL! 🎲🎉 ", // onelink.to/c3xadp",
	// SMS_MSG: "send-sms?&number=&body=I’m having fun playing HARD ROCK DICE PARTY – install now and LET’S ROLL! 🎲🎉 ", // onelink.to/c3xadp",
	MAIL_TO: () => emailSubj('email-subj-halo'),
	remotePath: remoteFolder + '/HRDP',
	eventConfig: remoteFolder + '/HRDP/eventsConfig.json',
	promoConfig: remoteFolder + '/HRDP/promoConfig.json',
	weekConfig: remoteFolder + '/HRDP/weekConfig.json',

	BUTTON_SCHEME: {
		topShadows: `inset 0 -0.5vw 1.25vw 0 topShadowColor, 
			inset 0 0.25vw 0.75vw 0 topShadowColor`,
		bottomShadows: `inset 0 -0.25vw 0.25vw 0 #ffffff1a,
			inset 0 -0.5vw 0.75vw 0 bottomShadowColor, 
			0 0.75vw 1.25vw #00000066`,
		blue: {
			bottomGrad: '#6472fa 0%,#423fb6 12%,#2c2b7c 50%,#423fb6 88%,#6472fa 100%',
			bottomShadowColor: '#4645c6',
			topGrad: '#8b96ff 0%,#6472fa 35%,#3c39ae 95%',
			topShadowColor: '#6965e2,#d6daff'
		},
		green: {
			bottomGrad: '#15af3e 0%,#0d7529 20%,#115e2b 50%,#0d7529 80%,#15af3e 100%',
			bottomShadowColor: '#118231',
			topGrad: '#75c957 0%,#71de49 35%,#119f37 95%',
			topShadowColor: '#1edd61,#cdec9a'
		},
		grey: {
			bottomGrad: '#737373 0%,#595959 20%,#474747 50%,#595959 80%,#737373 100%',
			bottomShadowColor: '#828282',
			topGrad: '#d1d1d1 0%,#a6a6a6 35%,#737373 95%',
			topShadowColor: '#999999,#ededed'
		},
		red: {
			bottomGrad: '#f4707c 0%,#d5243f 4%, #af162c 10%,#7f0e1e 35%, #7f0e1e 65%,#af162c 90%, #d5243f 96%, #f4707c 100%',
			bottomShadowColor: '#9f1226',
			topGrad: '#f4717c 5%,#d21f3b 65%,#b81628 100%',
			topShadowColor: '#ff3359,#ff8b96'
		},
		purple: {
			bottomGrad: '#a670e5 0%,#854cd4 8%, #6e3dcd 20%,#4e22a5 50%,#6e3dcd 80%,#854cd4 92%, #a670e5 100%',
			bottomShadowColor: '#7450ba',
			topGrad: '#cd9dff 0%,#aa6df0 35%,#612fc1 95%',
			topShadowColor: '#9877d7,#e1c5ff',
		},
		yellow: {
			bottomGrad: '#de6a24 0%,#a74913 15%,#8b3609 40%, #8b3609 60%,#a74913 85%,#de6a24 100%',
			bottomShadowColor: '#d1560e',
			topGrad: '#fdd856 0%,#fcc643 35%,#e06c24 95%',
			topShadowColor: '#f4b640,#fef197'
			//textColor: '#85380b'
		},
		black: {
			bottomGrad: '#414141 0%,#171717 20%,#0f0f0f 50%,#171717 80%,#414141 100%',
			bottomShadowColor: '#383838',
			topGrad: '#808080 0%,#414141 35%,#171717 95%',
			topShadowColor: '#4a4a4a,#cfcfcf'
		},
		unity: {
			bottomGrad: '#dbb666 0%,#cf9f35 8%,#b68a2b 16%,#87661e 35%,#87661e 65%,#b68a2b 84%,#cf9f35 92%,#dbb666 100%',
			bottomShadowColor: '#b78f2a',
			topGrad: '#ebd6a8 0%,#d6b151 50%,#cf9f35 100%',
			topShadowColor: '#ddbc45,#f1e2c2',
			textColor: '#101820'
		}
	}
}

export const Const = store.isHardRock 
	? {...SiuConstants, ...HardRockConstants}
	: SiuConstants;

